import appConfigCoverGoDev from "./appConfigCoverGoDev.js"
import { COVERGO_SAAS_DEV, COVERGO_SAAS_PROD } from "../consts.js"

export const coverHealthDev = {
	"cover-health-dev-studio.quote.hk": { appConfig: appConfigCoverGoDev, envConfig: COVERGO_SAAS_DEV },
	"cover-health-demo-studio.quote.hk": { appConfig: appConfigCoverGoDev, envConfig: COVERGO_SAAS_PROD }
}
